var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FB4E1F;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.7,44c-6.1,2.5-8.6,7.3-11.2,12.2c-1.6,3-3.5,5.9-5.2,8.8c7.5,1.5,16-2.5,19.8-9.4c1.7-3.1,3.4-6.3,5.2-9.4 c1.5-2.7,3.8-3.3,6.6-2.2c1.2,0.5,2.4,1,3.5,1.6c4.7,2.7,6.1,7.4,2.7,11.6c-2.8,3.5-6.4,6.7-10.2,8.9c-10.1,5.8-21.2,8-32.9,6.1 c-4.3-0.7-8.7-2.2-10-6.9c-1.4-4.7,1.7-8.2,5-11.1c6.8-6.1,15.2-9,24-10.7c0.4-0.1,0.8-0.1,1.2-0.1C46.4,43.4,46.7,43.6,47.7,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,40.4c1.5-2.1,2.5-3.9,3.8-5.4c4-4.3,9.2-6.7,14.9-6.9c14.4-0.6,28.9-0.6,43.4-0.8c0.4,0,0.7,0.2,1.7,0.6 c-1.1,1.6-1.8,3.2-3,4.5C76,38,69.1,40.6,61.5,40.7c-13,0.3-25.9,0.1-38.9,0.2C22.2,40.9,21.8,40.7,20.6,40.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank02);
export default __webpack_public_path__ + "static/media/icon-bank-02.5ca03d919b715b25f48be01779de0a17.svg";
export { ForwardRef as ReactComponent };